<template>
	<div class="col-12 pl-0 pr-0">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-4 pr-4 pt-2 pb-2 bg-light-blue mt-3 color-white cus-box-shadow rounded-cus font-size-10 d-flex">
				<i class="fas fa-box-open mt-auto mb-auto"></i>
				<div class="pl-2">Silahkan isi Form</div>
			</div>
			<div class="col-12 pl-4 pr-4 pt-4 pb-2 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
				<div class="col-lg-6 pl-0 pr-2">
					<div class="col-12 pl-0 pr-0 pb-1">
						<div class="pl-0 mt-auto mb-auto font-size-9">Kode Sponsor / No Handphone</div>
						<div class="col-12 pl-0 pr-0 pr-lg-3 pt-1">
							<input v-uppercase="registrationData.mitra_code" @focus="() => alert.mitra_code = '' " @change="checkMitra" v-model="registrationData.mitra_code" class="form-control form-control-sm box-blue rounded-cus font-size-10" type="text">
							<div v-if="!alert.mitra_code" class="font-size-8 pt-1 color-orange">Contoh : GSXXXXXX</div>
							<AlertInput v-if="alert.mitra_code" :message="alert.mitra_code"/>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 pt-2 pb-1">
						<div class="pl-0 mt-auto mb-auto font-size-9">Nama Sponsor</div>
						<div class="col-12 pl-0 pt-1">
							<input v-model="dataSponsor.name" class="form-control form-control-sm box-blue rounded-cus font-size-10" type="text" readonly>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 pt-2 pb-1">
						<div class="pl-0 mt-auto mb-auto font-size-9">Alamat Sponsor</div>
						<div class="col-12 pl-0 pt-1">
							<textarea v-model="dataSponsor.alamat" class="form-control form-control-sm box-blue rounded-cus font-size-10" type="text" readonly rows="4"> 
							</textarea>
						</div>
					</div>
				</div>
				<div class="col-lg-6 pl-0 pr-0">
					<div class="col-12 pl-0 pr-0 pb-1">
						<div class="pl-0 mt-auto mb-auto font-size-9">Nama Lengkap Mitra</div>
						<div class="col-12 pl-0 pt-1">
							<input @focus="() => alert.name = '' " v-model="registrationData.name" class="form-control form-control-sm box-blue rounded-cus font-size-10" type="text">
							<div v-if="!alert.name" class="font-size-8 pt-1 color-orange">Sesuaikan dengan nama rekening Mitra</div>
							<AlertInput v-if="alert.name" :message="alert.name"/>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 pt-2 pb-1">
						<div class="pl-0 mt-auto mb-auto font-size-9">Email Mitra</div>
						<div class="col-12 pl-0 pt-1">
							<input @focus="() => alert.email = '' " v-model="registrationData.email" class="form-control form-control-sm box-blue rounded-cus font-size-10" type="text" @change="validateEmail">
							<AlertInput v-if="alert.email" :message="alert.email"/>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 pt-2 pb-1">
						<div class="pl-0 mt-auto mb-auto font-size-9">Nomor KTP</div>
						<div class="col-12 pl-0 pt-1">
							<input @focus="() => setAlertMandatory({
							'type':'ktp', 'data': ''})" @keypress="onlyNumber" maxlength="16" v-model="registrationData.card_id" @change="checkKtp" class="form-control form-control-sm box-blue rounded-cus font-size-10" type="text">
							<AlertInput v-if="mandatoryError.ktp" :message="mandatoryError.ktp"/>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 pt-2 pb-1">
						<div class="pl-0 mt-auto mb-auto font-size-9">Nomor Handphone</div>
						<div class="col-12 pl-0 pt-1">
							<input maxlength="14" @keypress="onlyNumber" @focus="setAlertMandatory({'type':'hp', 'data': ''})" v-model="registrationData.mobilephone" class="form-control form-control-sm box-blue rounded-cus font-size-10" type="text" @change="checkhp">
							<AlertInput v-if="mandatoryError.hp" :message="mandatoryError.hp"/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Settings } from 'luxon';
Settings.defaultLocale = 'id';
import { mapState, mapActions, mapMutations} from 'vuex';
import AlertInput from '@/components/elements/alert/AlertInput.vue';
import validator from 'validator';

export default {
	components: {
		AlertInput
	},
	props: {
		registrationData: {
			type: Object
		},
		alert: {
			type: Object
		}
	},
	data() {
		return {
			sPassword : true,
			rPassword : true,
			dataSponsor: {
				name: '',
				alamat: ''
			},
		}
	},
	computed: {
		...mapState('commonList', ['mitraMLM', 'dataProvince', 'dataCity', 'mandatoryError']),
		...mapState('auth', ['userData']),

		maxdate(){
			var date = new Date(new Date().setFullYear(new Date().getFullYear()-17)).toISOString()
			return date;
		},
	},
	methods: {
		...mapActions('commonList', ['getmitraMLM', 'getDataArea', 'checkMandatory']),
		...mapMutations('commonList', ['setAlertMandatory']),

		checkMitra(){
			this.alert.mitra_code = ''
			if (!this.registrationData.mitra_code) {
				this.alert.mitra_code = 'Kode Mitra tidak boleh kosong'
			} else {
				this.getmitraMLM({
					member_network_mid: this.registrationData.mitra_code
				}).then( () => {
					if (!this.mitraMLM.status) {
						this.alert.mitra_code = 'Kode Mitra tidak ditemukan'
					} else {
						this.dataSponsor.name = this.mitraMLM.name
						this.dataSponsor.alamat = this.kotaprovinsi(this.mitraMLM)
					}
				})
			}
		},
		kotaprovinsi(data){
			let result = []
			if (data.address)
				result.push(data.address)
			if (data.city_name)
				result.push(data.city_name)
			if (data.province_name)
				result.push(data.province_name)
			return result.join(', ')
		},
		validateEmail(){
			let valid = validator.isEmail(this.registrationData.email)
			if(!valid){
				this.alert.email = "Email tidak valid"
			} else {
				this.alert.email = ""
			}
		},
		getCity(){
			if (this.registrationData.province.area_id) {
				this.alert.province = ''
				this.getDataArea({type: "city", province: this.registrationData.province.area_id})
			} else {
				this.alert.province = 'Data tidak boleh kosong'
			}
		},
		checkKtp(){
			if (!this.registrationData.card_id) {
				this.setAlertMandatory({type:'ktp', data: "Data tidak boleh kosong"})
			} else {
				const valid = validator.isLength(this.registrationData.card_id , {min:16 , max:16})
				if(!valid){
					this.setAlertMandatory({type:'ktp', data: "KTP tidak valid"})
				} else {
					this.checkMandatory({type:'ktp', data: this.registrationData.card_id})
				}
			}
		},
		checkhp(){
			if (!this.registrationData.mobilephone) {
				this.setAlertMandatory({type:'hp', data: "Data tidak boleh kosong"})
			} else {
				const valid = validator.isLength(this.registrationData.mobilephone , {min:10 , max:14})
				if(!valid){
					this.setAlertMandatory({type:'hp', data: "Nomor tidak valid"})
				} else {
					this.checkMandatory({type:'hp', data: this.registrationData.mobilephone})
				}
			}
		},
		checkDate(){
			if (this.registrationData.borndate) {
				this.alert.borndate = ''
			} else {
				this.alert.borndate = 'Data tidak boleh kosong'
			}
		},
		showPassword() {
			var x = document.getElementById("in-password");
			if (x.type === "password") {
				x.type = "text"
				this.sPassword = false
			} else {
				x.type = "password"
				this.sPassword = true
			}
		},
		showRePassword() {
			var x = document.getElementById("re-password");
			if (x.type === "password") {
				x.type = "text"
				this.rPassword = false
			} else {
				x.type = "password"
				this.rPassword = true
			}
		},
	},
	created(){
		this.getDataArea({type: "province"})
		this.registrationData.mitra_code = this.userData.stockist_network_mid
		this.dataSponsor.name = this.userData.stockist_name
		this.dataSponsor.alamat = this.kotaprovinsi({
			city_name: this.userData.stockist_origin_city_name,
			province_name: this.userData.stockist_origin_province_name,
			address: this.userData.stockist_origin_address,
		})
	},
	mounted(){
		
	}
};
</script>